import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ItemShape } from 'types';
import {
  TableRow,
  CenterCell,
  LeadNumberCell,
  PrefixPhone,
  DurationCell,
} from '../../../assets/styles/sharedStyles/sharedStyles';
import { formatDuration, formatPhoneNumber, formatDateTime } from 'helpers';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Eye from '../VisiblityEye/VisiblityEye';
import _ from 'lodash';

const Item = ({
  item: {
    talk_id,
    lead_number,
    start_time,
    duration,
    phone_number,
    logical_status_id,
    business_status_id,
    other_talks,
  },
  addDataToModal,
  isLastOpenItem,
  setShowNested,
  setRowIndex,
  rowIndex,
  showNested,
  all_talks_count,
  setLastOpenItemId,
  lastOpenItemId,
}) => {
  const [clickedStatus, setClickedStatus] = useState(false);
  const [colored, setColored] = useState(false);
  const openModal = () => {
    addDataToModal({ talk_id });
    setClickedStatus(true);
  };

  const handleMouseDown = (e) => {
    if (e.button === 1) {
      window.open(`${window.location.origin}${window.location.pathname}/!${talk_id}`, '_blank');
    }
  };

  const showRecord = (e) => {
    setRowIndex(talk_id);
    setShowNested(true);
    setColored(true);
    setLastOpenItemId(talk_id);
    if (!e) {
      const e = window.event;
    }
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
  };

  const hideRecord = (e) => {
    setShowNested(false);
    setColored(false);
    if (!e) {
      const e = window.event;
    }
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
  };

  useEffect(() => {
    if (talk_id === rowIndex) {
      setColored(true);
    } else {
      setColored(false);
    }
  }, [talk_id, rowIndex]);

  return (
    <>
      <TableRow
        onClick={openModal}
        onMouseDown={handleMouseDown}
        isLastOpenItem={isLastOpenItem}
        key={talk_id}
        colored={colored}
      >
        <CenterCell style={{ pointerEvents: 'none' }}>
          <Eye talk_id={talk_id} isLastOpenItem={isLastOpenItem} clickedStatus={clickedStatus} />
        </CenterCell>

        <LeadNumberCell>
          &nbsp;
          {other_talks && Object.keys(other_talks).length !== 0 ? (
            showNested && rowIndex === talk_id ? (
              <>
                <ExpandLessIcon onClick={hideRecord} key={talk_id} />
                {lead_number} ({all_talks_count})
              </>
            ) : (
              <>
                <ExpandMoreIcon onClick={showRecord} key={talk_id} />
                {lead_number} ({all_talks_count})
              </>
            )
          ) : (
            <>
              <ExpandLessIcon style={{ opacity: 0 }} />
              {lead_number}
            </>
          )}
        </LeadNumberCell>
        <CenterCell>
          {phone_number && (
            <>
              <PrefixPhone>{phone_number.startsWith('+48') ? `${phone_number.slice(0, 3)}` : ''}</PrefixPhone>
              {formatPhoneNumber(phone_number)}
            </>
          )}
        </CenterCell>
        <CenterCell>{start_time && <>{formatDateTime(start_time)}</>}</CenterCell>
        <DurationCell>{formatDuration(duration)}</DurationCell>
        <CenterCell>{logical_status_id}</CenterCell>
        <CenterCell>{business_status_id}</CenterCell>
      </TableRow>
    </>
  );
};

Item.propTypes = {
  item: PropTypes.shape(ItemShape),
  addDataToModal: PropTypes.func.isRequired,
};

export default Item;
